import React from 'react';
import styled, { css } from 'styled-components';
import { isMobileOnly } from 'react-device-detect';
import {
  FlexBox,
  Heading3,
  Icons,
} from '@docon/docon-ui-library';
import { bgColor, colors } from 'utilities/colorConfig';

const Root = styled(FlexBox)`
  position: sticky;
  top: 0;
  gap: 10px;
  font-weight: bold;
  padding: 12px 0;
  align-items: center;
  flex: 0 0 auto;
  background-color: ${bgColor.base};

  ${() => isMobileOnly && css`
    padding: 22px 16px;
    z-index: 1;
    background-color: ${colors.white};
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
  `}
`;

const HeaderNavBar = ({
  className,
  title = 'Help & Support',
  onBackIconClick,
  ...props
}: any) => {

  function handleBackIconClick() {
    if (onBackIconClick) {
      onBackIconClick();
    } else
      history.back();
    // history.push('/support/');
  }

  return (
    <Root className={className} {...props}>
      <Icons.BackIcon className={'clickable'} onClick={handleBackIconClick} />
      <Heading3
        mb={0}
        title={title}
      />
    </Root>
  );
};

export default styled(HeaderNavBar)``;